var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFoodleLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 133.677,
    height: 26,
    viewBox: "0 0 133.677 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_4",
    d: "M0 0h32.131v5.274H0z",
    className: "cls-1",
    transform: "translate(0 .137)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_11",
    d: "M0 0h17.256v17.9H0z",
    className: "cls-1",
    transform: "translate(.797 .101)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_18",
    d: "M0 0h9.227v25.421H0z",
    className: "cls-1",
    transform: "translate(.642 .145)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_21",
    d: "M0 0h15.1v18.019H0z",
    className: "cls-1",
    transform: "translate(.578 .936)"
  })), /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1{fill:none}.cls-2{fill:#fff}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    transform: "translate(0 -.018)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    d: "M24 .177L23.365 3.4l-.267.918a.916.916 0 0 1-.9.643c-2.44-.025-10.348-.108-11-.108-.772 0-8.933.145-8.933.145L.912 4.981A.885.885 0 0 1 .027 3.9l.545-2.093.147-.893a.907.907 0 0 1 .917-.739C3.518.185 8.194.21 9.658.21c1.848 0 8.007-.146 8.624-.146s4.62-.145 5.236 0z",
    className: "cls-2",
    transform: "translate(10 1.018)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    transform: "translate(0 11.018)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_4-2",
    d: "M0 0h32.131v5.274H0z",
    className: "cls-1",
    transform: "translate(0 .137)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5-2",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_3",
    d: "M31.455 0a.666.666 0 0 1 .656.833 14.192 14.192 0 0 0-.381 1.9 14.59 14.59 0 0 1-.36 1.917.654.654 0 0 1-.7.511c-.767-.078-2.113-.205-2.651-.205-.772 0-8.189.318-8.807.318s-9.581-.16-10.2-.16c-.489 0-6.059.06-8.361.084a.667.667 0 0 1-.606-.928l.628-1.541.771-2.117a.655.655 0 0 1 .6-.436l9.446-.15 14.988.158z",
    className: "cls-2",
    transform: "translate(0 .137)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill_6",
    d: "M17.982.772L17.6 2.205l-.451 2.255a.611.611 0 0 1-.6.474L10.247 5H4.924L.607 4.936a.59.59 0 0 1-.59-.718l.368-1.425L.847.535a.611.611 0 0 1 .6-.471C3.247.05 9.268 0 9.934 0h5.008c.406 0 1.642.031 2.461.053a.586.586 0 0 1 .579.719",
    className: "cls-2",
    transform: "translate(12 20.018)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_8",
    d: "M1.14 24.99a1.139 1.139 0 0 1-1.118-1.365c.25-1.294.621-3.117.816-3.707a29.313 29.313 0 0 0 1.251-3.962 54.158 54.158 0 0 1 .937-5.7A27.691 27.691 0 0 0 4.12 5.182c.106-1.078.5-3.094.739-4.271A1.131 1.131 0 0 1 5.979 0L16 .111h4.846a1.141 1.141 0 0 1 1.129 1.382l-.5 2.421-.113.512a1.13 1.13 0 0 1-1.163.893c-1.643-.092-4.957-.253-6.228-.136-1.721.158-4.438.1-4.438.1l-1.12 5.291s6.5.152 7.433-.006a20.1 20.1 0 0 1 2.769-.047 1.142 1.142 0 0 1 1.056 1.441 12.7 12.7 0 0 0-.385 1.775 6.98 6.98 0 0 1-.128.977 1.127 1.127 0 0 1-1.116.937c-1.74-.012-5.357-.051-5.947-.172a39.312 39.312 0 0 0-4.722.175s-.906 4.263-1.22 5.213a29.114 29.114 0 0 0-.621 3.215A1.073 1.073 0 0 1 4.471 25l-3.007-.012z",
    className: "cls-2",
    transform: "translate(34 1.018)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    transform: "translate(54 8.018)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_11-2",
    d: "M0 0h17.256v17.9H0z",
    className: "cls-1",
    transform: "translate(.797 .101)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12-2",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_10",
    d: "M7.4 17.9c-.164 0-.329 0-.491-.01A6.723 6.723 0 0 1 2.1 15.213 8.793 8.793 0 0 1 .059 10.65a11.355 11.355 0 0 1 .26-4.027 10.381 10.381 0 0 1 2.049-3.712A7.724 7.724 0 0 1 6.469.4 10.928 10.928 0 0 1 8.882 0a8.392 8.392 0 0 1 5.656 2.151c4.221 3.329 2.5 8.923 1.558 11.174C14.974 16.018 11.4 17.9 7.4 17.9zM8.753 4.658A3.909 3.909 0 0 0 5.4 6.557c-1.356 2.16-.732 4.664.312 5.508a4.822 4.822 0 0 0 2.8 1.093 2.987 2.987 0 0 0 2.073-.83 4.817 4.817 0 0 0 1.817-4.564 4.445 4.445 0 0 0-.902-2.085 2.909 2.909 0 0 0-2.319-1.015h-.195a2.259 2.259 0 0 0-.233-.006z",
    className: "cls-2",
    transform: "translate(.797 .101)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill_13",
    d: "M8.491 18a9.807 9.807 0 0 1-4.8-1.44A7.117 7.117 0 0 1 .9 13.274 9.978 9.978 0 0 1 0 9.315 9.582 9.582 0 0 1 3.846 1.7 9.621 9.621 0 0 1 9.17 0c.168 0 .263.007.264.007 2.048.052 3.519.989 5.229 2.485 1.689 1.48 2.512 5.023 2.306 7.456a8.119 8.119 0 0 1-1.416 3.775 10.89 10.89 0 0 1-3.453 3.26A6.958 6.958 0 0 1 8.491 18zm.231-13.345a3.27 3.27 0 0 0-.622.059 4.981 4.981 0 0 0-2.513 1.85 5.3 5.3 0 0 0-.768 4.23 3.379 3.379 0 0 0 3.051 2.423 2.976 2.976 0 0 0 .487-.041 5.674 5.674 0 0 0 2.447-.933A3.285 3.285 0 0 0 12.1 10.16c.58-2.99-.062-3.833-.769-4.441a3.971 3.971 0 0 0-2.609-1.064z",
    className: "cls-2",
    transform: "translate(73 8.018)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_15",
    d: "M7.233 26a9.922 9.922 0 0 1-1.512-.118A6.43 6.43 0 0 1 2.1 23.85a7.627 7.627 0 0 1-1.95-3.738 12.248 12.248 0 0 1 .1-4.36 11.952 11.952 0 0 1 1.272-3.685 8.476 8.476 0 0 1 3.135-2.923c.2-.124.382-.24.559-.358a7.371 7.371 0 0 1 3.729-.823c.291 0 .586.01.877.029a6.506 6.506 0 0 1 3.188 1.589l.506-2.7.841-6.3a.621.621 0 0 1 .58-.55L15.691 0h2.7a.6.6 0 0 1 .46.219.657.657 0 0 1 .139.543l-.919 4.848c-.011.074-1.117 7.431-1.417 9.1-.249 1.4-1.234 8.078-1.592 10.535a.62.62 0 0 1-.589.539l-1.665.041h-1.313a.6.6 0 0 1-.452-.211.655.655 0 0 1-.148-.527l.04-.268C10.6 25.394 9.185 26 7.233 26zm1.505-13.3a5.361 5.361 0 0 0-2.763 1.115c-.872.608-1.472 2.375-1.366 4.023a4 4 0 0 0 .809 2.256A3.329 3.329 0 0 0 7.9 21.277c.085.006.171.009.255.009a4.255 4.255 0 0 0 3.338-1.914c0-.024.406-2.435.406-2.594s.291-2.341.3-2.434a2.776 2.776 0 0 0-.911-.953A5.714 5.714 0 0 0 8.86 12.7h-.122z",
    className: "cls-2",
    transform: "translate(91 .018)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    transform: "translate(109 .018)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_18-2",
    d: "M0 0h9.227v25.421H0z",
    className: "cls-1",
    transform: "translate(.642 .145)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19-2",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_17",
    d: "M4.028.535a.6.6 0 0 1 .586-.492C5.41.028 6.883 0 7 0c.1 0 .974.02 1.629.035a.6.6 0 0 1 .587.708c-.429 2.211-1.745 9.01-1.789 9.491-.054.573-.64 3.393-.854 4.49s-1.123 7.362-1.229 7.884c-.075.363-.279 1.564-.4 2.258a.6.6 0 0 1-.61.5c-.886-.013-2.6-.032-2.839.008-.154.024-.526.038-.873.045a.6.6 0 0 1-.618-.691c.237-1.469.779-4.792.9-5.358.161-.732.962-6.526 1.23-7.571s1.287-7.152 1.394-8.144c.078-.726.357-2.318.5-3.12",
    className: "cls-2",
    transform: "translate(.642 .145)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    transform: "translate(118 7.018)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_21-2",
    d: "M0 0h15.1v18.019H0z",
    className: "cls-1",
    transform: "translate(.578 .936)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22-2",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_20",
    d: "M7.469 18.018a6.658 6.658 0 0 1-3.025-.76 8.03 8.03 0 0 1-2.78-2.405C-.006 12.6-.479 8.758.515 5.515A7.856 7.856 0 0 1 3.524 1.64 8.151 8.151 0 0 1 7.507.006C7.6 0 7.7 0 7.79 0a6.894 6.894 0 0 1 5.261 2.526A9.169 9.169 0 0 1 15.1 7.667a7.708 7.708 0 0 1-.5 2.78H4.11a11.961 11.961 0 0 0 .95 2.15 4.254 4.254 0 0 0 3.346 1.26A6.549 6.549 0 0 0 11.8 12.7a.339.339 0 0 1 .187-.056.345.345 0 0 1 .3.179L13 14.068l.662 1.39a.718.718 0 0 1-.2.878c-.674.514-2.293 1.414-5.558 1.666-.141.011-.288.016-.435.016zM9.805 6.67l.9.052c0-.021-.335-2.258-2.2-2.413-.285-.024-.535-.035-.763-.035a2.489 2.489 0 0 0-2.433 1.241 5.932 5.932 0 0 0-.749 1.207h2.947z",
    className: "cls-2",
    transform: "translate(.578 .936)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodleLogo);
export default __webpack_public_path__ + "static/media/foodle-logo.b787e96d7aa12821c9acfb8f51b32e7b.svg";
export { ForwardRef as ReactComponent };